import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerRequestService } from './customer-request-queue.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';

export class CustomerRequestContext {
    constructor(public customerRequestId: number) {}
}

@Component({
    templateUrl: './customer-request-modal.html'
})
export class CustomerRequestModalComponent extends BaseComponent {
    customerRequest: any =
        {
            firstName: '',
            middleName: '',
            lastName: '',
            dateOfBirth: null,
            ssn: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            jurisdictionDisplayValue: '',
            postalZipCode: '',
            countryDisplayValue: '',
            phoneNumber: '',
            emailAddress: '',
            comment: '',
        };

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<CustomerRequestModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CustomerRequestContext,
        public customerRequestService: CustomerRequestService
    ) {
        super();

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() {
        this.customerRequestService.getCustomerRequest(this.data.customerRequestId).subscribe(
            data => {
                this.customerRequest = data;
            }
        );
    }

    public cancel() {
        this.dialogRef.close();
    }
}
